module.exports = __webpack_public_path__ + "assets/img/language-en.e92c3937.png";